import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import {
  review_Actions,
  get_otp,
  update_env,
  get_rejected_approvers,
  cancelEnvelope,
  approve_env
} from './api';

const initialState = {
  all_file_data: {},
  otp: '',
  rejected_approvers: [],
  allFileLoading: false
};

const actions = {
  GET_FILE_BY_ID: 'getfilebyid/GET_FILE_BY_ID',
  GET_OTP: 'getOtp/GET_OTP',
  UPDATE_ENVELOPE: 'update_envelope/UPDATE_ENVELOPE',
  GET_REJECTED_APPROVERS: 'getRejectedApprovers/GET_REJECTED_APPROVERS',
  CANCEL_ENVELOPE: 'cancel_envelope/CANCEL_ENVELOPE',
  APPROVE_ENVELOPE: 'approve_envelope/APPROVE_ENVELOPE',
  REJECT_ENVELOPE: 'reject_envelope/REJECT_ENVELOPE',
  FORWARD_ENVELOPE: 'forward_envelope/FORWARD_ENVELOPE',
  RETURN_ENVELOPE: 'return_envelope/RETURN_ENVELOPE'
};

export const getfilebyid = createAsyncThunk(
  actions.GET_FILE_BY_ID,
  async (payload) => {
    const response = await review_Actions(
      // `all-action-list?id=${payload}`,
      `?id=${payload}`,
      payload
    );
    return response;
  }
);

export const getOtp = createAsyncThunk(actions.GET_OTP, async (payload) => {
  const response = await get_otp(`send-otp`, payload);
  return response;
});

export const update_envelope = createAsyncThunk(
  actions.UPDATE_ENVELOPE,
  async (payload) => {
    const response = await update_env(payload);
    return response;
  }
);
// approve_envelope
export const approve_envelope = createAsyncThunk(
  actions.APPROVE_ENVELOPE,
  async (payload) => {
    console.log('payloadSlice', payload);
    try {
      const response = await approve_env(`approve`, payload);
      return response;
    } catch (error) {
      console.error('Approve error:', error);
      throw error;
    }
  }
);
// reject_envelope
export const reject_envelope = createAsyncThunk(
  actions.REJECT_ENVELOPE,
  async (payload) => {
    const response = await approve_env(`reject`, payload);
    return response;
  }
);

// forward_envelope
export const forward_envelope = createAsyncThunk(
  actions.FORWARD_ENVELOPE,
  async (payload) => {
    const response = await approve_env(`forward`, payload);
    return response;
  }
);

// return_envelope
export const return_envelope = createAsyncThunk(
  actions.RETURN_ENVELOPE,
  async (payload) => {
    const response = await approve_env(`return`, payload);
    return response;
  }
);

export const cancel_envelope = createAsyncThunk(
  actions.CANCEL_ENVELOPE,
  async (payload) => {
    const response = await cancelEnvelope(`cancel_envelope`, payload);
    return response;
  }
);

export const getRejectedApprovers = createAsyncThunk(
  actions.GET_REJECTED_APPROVERS,
  async (payload) => {
    const response = await get_rejected_approvers(
      `env-accepters-list?envelope_id=${payload.envelope_id}`,
      payload
    );
    return response;
  }
);

export const getReviewsSlice = createSlice({
  name: 'reviewActions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getfilebyid.pending, (state) => {
        state.allFileLoading = true;
      })
      .addCase(getfilebyid.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.all_file_data = data;
        state.allFileLoading = false;
      })
      .addCase(getfilebyid.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.allFileLoading = false;

        message.error(msg);
      });

    builder
      .addCase(getOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOtp.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.otp = data;
      })
      .addCase(getOtp.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(update_envelope.pending, (state) => {
        state.loading = true;
      })
      .addCase(update_envelope.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(update_envelope.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(cancel_envelope.pending, (state) => {
        state.loading = true;
      })
      .addCase(cancel_envelope.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(cancel_envelope.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(getRejectedApprovers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRejectedApprovers.fulfilled, (state, action) => {
        const { success, message: msg, data } = action.payload;
        state.rejected_approvers = data;
        if (!success) {
          message.error(msg);
        }
      })
      .addCase(getRejectedApprovers.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(approve_envelope.pending, (state) => {
        state.loading = true;
      })
      .addCase(approve_envelope.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(approve_envelope.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(reject_envelope.pending, (state) => {
        state.loading = true;
      })
      .addCase(reject_envelope.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(reject_envelope.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(forward_envelope.pending, (state) => {
        state.loading = true;
      })
      .addCase(forward_envelope.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(forward_envelope.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(return_envelope.pending, (state) => {
        state.loading = true;
      })
      .addCase(return_envelope.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(return_envelope.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
  }
});

/* export const getTrackersActions = getReviewsSlice.actions; */
/* export const { resetTrackers } = getReviewsSlice.actions; */

export default getReviewsSlice.reducer;
